import * as e from "react";
const o = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4a8 8 0 110 16 8 8 0 010-16zm10 8c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zM8.5 8a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM14 9.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-2 6.496A4.648 4.648 0 019.137 15h5.726c-.819.64-1.823.996-2.863.996zm0 2c2.421 0 4.658-1.332 5.87-3.496.173-.309.173-.688.002-.997a.964.964 0 00-.835-.503H6.963a.964.964 0 00-.835.503c-.171.309-.17.688.002.997 1.212 2.164 3.449 3.496 5.87 3.496z",
      fill: "#2d6ded"
    }
  )
), t = o;
export {
  t as default
};
